import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.75 1.375v14.438c0 .386.3.687.688.687h17.187c.73 0 1.375.645 1.375 1.375 0 .773-.645 1.375-1.375 1.375H3.438C1.504 19.25 0 17.746 0 15.813V1.374C0 .645.602 0 1.375 0c.73 0 1.375.645 1.375 1.375m17.445 3.738-5.5 5.5a1.325 1.325 0 0 1-1.933 0l-2.45-2.449-3.867 3.824a1.325 1.325 0 0 1-1.933 0 1.325 1.325 0 0 1 0-1.933l4.812-4.813a1.325 1.325 0 0 1 1.934 0l2.492 2.45 4.512-4.512a1.325 1.325 0 0 1 1.933 0 1.325 1.325 0 0 1 0 1.933"
    }, null, -1)
  ]))]))
}
export default { render: render }